import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import OrderFulfillmentsManager from '../../../../services/api/OrderFulfillmentsManager';
import { OrderFulfillmentStatus } from '../../../../services/exports/Constants';
import { useOngoingOrders } from '../../../../providers/OngoingOrdersProvider';
import { Button } from 'antd';
import FooterWrapper from './FooterWrapper';

export default function ScheduledOrderStartPreparation({ order, onError }) {
  const { t } = useTranslation(null, {
    keyPrefix: 'Modals:Order:OrderDetails:Footers:ScheduledOrderStartPreparation',
  });

  const { replaceOrderData, toggleOrderDetailsModal } = useOngoingOrders();

  const [loading, setLoading] = useState(false);

  async function startPreparation() {
    setLoading(true);
    const { success, data } = await OrderFulfillmentsManager.update(order.fulfillment_id, {
      status: OrderFulfillmentStatus.Preparing,
    });
    setLoading(false);

    if (!success) {
      return onError(data?.message);
    }

    replaceOrderData(data.data);
    toggleOrderDetailsModal();
  }

  return (
    <FooterWrapper className="px-md">
      <Button
        onClick={startPreparation}
        variant="solid"
        className="w-full bg-orange-500 hover:!bg-orange-500/75 !text-white py-lg"
        loading={loading}
      >
        {t('buttons.start')}
      </Button>
    </FooterWrapper>
  );
}
